<script setup lang="ts">
import type { CategoryNode } from "@/modules/api/gql/types/category";
import { ROUTE_BLOG_CATEGORY } from "~/constants/routes";

const route = useRoute();
const { replaceParams } = useRouteParams();

defineProps<{
  categories: CategoryNode[];
}>();

const currentCategory = computed(() => route.params.slug);
</script>

<template>
  <div class="tw-z-10 tw-sticky tw-top-0 tw-bg-nl-yellow-100 tw-shadow-nl-19 tw-mb-8 sm:tw-mb-[42px]">
    <div class="tw-max-w-[1180px] tw-mx-auto lg:tw-px-[17px] tw-flex tw-relative">
      <slot name="search" />
      <div
        v-if="categories.length > 0"
        class="tw-overflow-x-auto hide-scrollbar md:tw-ml-2.5 tw-flex-1"
      >
        <ul
          class="tw-table tw-w-full tw-whitespace-nowrap tw-font-agenda tw-font-bold tw-text-[15px] tw-uppercase tw-text-center tw-tracking-[0.02em] tw-mr-[-25px]"
        >
          <li
            v-for="category in categories"
            :key="category.id"
            class="tw-table-cell"
            :class="{ active: category.slug === currentCategory }"
          >
            <nuxt-link
              :to="{path: replaceParams(ROUTE_BLOG_CATEGORY, {slug: category?.slug})}"
              class="tw-group tw-relative tw-block tw-w-full tw-px-2.5 sm:tw-px-[23px] tw-py-4 md:tw-pt-[23px] md:tw-pb-[27px] tw-text-nl-green-100 hover:tw-text-nl-green-200 [&.router-link-active]:tw-text-nl-green-200 tw-cursor-pointer !tw-outline-offset-[-3px]"
            >
              {{ category.name }}
              <i class="group-[.router-link-active]:tw-w-full group-hover:tw-w-full tw-rounded-lg tw-absolute tw-bottom-0 tw-left-1/2 tw-h-1 tw-w-0 tw-bg-nl-green-200 -tw-translate-x-1/2 tw-transition-all"></i>
            </nuxt-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
